import { Reveal, SectionHeading } from "./Reveal";

const PHOTOS = [
  { src: "/images/garage.jpg", alt: "Mechanic working on an engine at Auto Trust Centre" },
  { src: "/images/work-tech1.jpg", alt: "Technician balancing a tire at Auto Trust Centre" },
  { src: "/images/tires.jpg", alt: "Professional tire service and wheel work" },
  { src: "/images/shop-hero.jpg", alt: "Inside the Auto Trust Centre service bays with vehicles on lifts" },
  { src: "/images/work-tech2.jpg", alt: "Technician mounting a tire at Auto Trust Centre" },
  { src: "/images/diagnostic.jpg", alt: "Technician performing vehicle diagnostics" },
];

export const Gallery = () => (
  <section id="gallery" className="bg-[#0b0c0e] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <SectionHeading kicker="Photo Gallery" title="Inside the Shop" />
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#a6a9b1]">
          A look at our bays, equipment and day-to-day work at 5040 Maingate Dr
          in Mississauga.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-3">
        {PHOTOS.map((p, i) => (
          <Reveal key={p.src} delay={(i % 3) * 0.08}>
            <div className="image-frame group overflow-hidden bg-[#17181c]">
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
